import {
  CreateMedigapQuoteFromMedicareQuoteMutation,
  CreateMedigapQuoteFromMedicareQuoteMutationVariables,
  useCreateMedigapQuoteFromMedicareQuoteMutation,
} from '@coverright/data-access/types/medigap';
import * as Apollo from '@apollo/client';
import { useDebouncedEffect } from '@coverright/utils';

export function useCreateMgQuoteIfNotExists(
  quoteId?: string | null,
  medigapQuoteId?: string | null,
  baseOptions?: Apollo.MutationHookOptions<
    CreateMedigapQuoteFromMedicareQuoteMutation,
    CreateMedigapQuoteFromMedicareQuoteMutationVariables
  >
) {
  const [createQuote] =
    useCreateMedigapQuoteFromMedicareQuoteMutation(baseOptions);

  useDebouncedEffect(
    () => {
      if (quoteId && !medigapQuoteId) {
        createQuote({
          variables: {
            medicareQuoteId: quoteId,
          },
        });
      }
    },
    600,
    [quoteId, medigapQuoteId, createQuote]
  );
}
